import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * Keeps the open accordion item in the URL query param `req`, so it survives
 * filter changes, pagination and the reload after saving a result.
 */
export function useOpenRequirement() {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const raw = params.get('req');
  const openTypeId = raw ? Number(raw) : null;

  const setOpenTypeId = useCallback(
    (typeId: number | null) => {
      const next = new URLSearchParams(location.search);
      if (typeId == null) {
        next.delete('req');
      } else {
        next.set('req', String(typeId));
      }
      history.replace({ search: next.toString() });
    },
    [history, location.search],
  );

  return { openTypeId, setOpenTypeId };
}
